module.exports = __webpack_public_path__ + "img/chevy-New.cbbcebac.png";